
import { IAnimalFilter } from "../models/filters/animalFilter";
import { IFilter } from "../models/filters/filter";
import _o2sService from "./_o2sServices";
import { API_CENTRE } from "./config";
import { IBoarForm } from "../models/forms/boarForm";
import { IBoarPDTO } from "../models/dtos/boarPDTO";
import { apiCallWithAuth } from "../helper/apiManager";


export default class BoarServices extends _o2sService
{
    protected static override mainUrl:string = API_CENTRE + "/api/v1/boars";
    protected static override getUrlFilter<F extends IAnimalFilter>(filter?: F): string {
        let url = super.getUrlFilter(filter as IFilter);

        if ( filter != undefined)
        {
            if ( filter.idCenter != undefined)
                url += `&IdCenter=${filter.idCenter}`;
            if ( filter.isReform != undefined)
                url += `&IsReform=${filter.isReform}`;
            if ( filter.isUsual != undefined)
                url += `&IsUsual=${filter.isUsual}`;
            if ( filter.isPresent != undefined)
                url += `&IsPresent=${filter.isPresent}`;
            if ( filter.isRecentReform != undefined)
                url += `&IsRecentReform=${filter.isRecentReform}`;
            if ( filter.state != undefined)
                url += `&State=${filter.state}`;
            if ( filter.psLotId != undefined)
                url += `&PsLotId=${filter.psLotId}`;
        }
        return url;
    }

    static async getLastQuarantineCycle( idCenter: number) {
        try {
            let result = await apiCallWithAuth(this.mainUrl + `/lastquarantine?idCenterAnimal=${idCenter}`, "get");
            return this.ReturnAttribut<string>(result);
        } catch (err:any) {
            return this.ReturnAttributError<string>(err);
        }
    }

    protected static override toDTO(obj:IBoarForm):IBoarPDTO {
        const dto = super.toDTO(obj) as IBoarPDTO;
        // Map pslotId (form) → psLotId (DTO) et supprime la propriété périmée
        // copiée par Object.assign depuis la réponse API (psLotId ≠ pslotId en JS)
        dto.psLotId = obj.pslotId;
        delete (dto as any).pslotId;
        return dto;
    }
}
